import { Card, Col, Markdown } from "@/atoms"
import { isCodeIssueType } from "@/domain/issue"
import { Heading } from "@/molecules/Heading"
import { LineClamp } from "@/molecules/LineClamp"
import { SkeletonsBlock } from "@/molecules/SkeletonsBlock"

import styles from "./DescriptionIssueCard.module.scss"

import type { DescriptionIssueCardComponent } from "."

export const DescriptionIssueCard: DescriptionIssueCardComponent = (props) => {
  const { t, record } = props

  if (!record) return <SkeletonsBlock />

  if (record.description === "") return null

  const isCodeIssue = isCodeIssueType(record.issueType)

  return (
    <Col span={24}>
      <Card
        className="embedded-card-ks"
        title={<Heading level={5} title={t("general.description")} />}
      >
        <LineClamp clamp={3} classes={{ container: styles.container }}>
          {isCodeIssue && record.description}
          {!isCodeIssue && <Markdown content={record.description} />}
        </LineClamp>
      </Card>
    </Col>
  )
}
